<template>
  <div class="channel b">
    <!-- 频道超出时行内可左右滑动：触控板/Shift+滚轮走原生滚动，
         鼠标按住拖动由下面几个 mousedown/move/up 处理（拖动结束不触发切换） -->
    <ul
      ref="tabList"
      class="Tab b"
      :class="{ canScroll, dragging }"
      @mousedown="onDragStart"
    >
      <!-- <li @click="toHome()" :class="isHome ? 'active' : ''">
        <span>商城首页</span>
      </li>-->
      <li
        v-for="(item, index) in channelData"
        :key="index"
        @click="changeChannel(item)"
        class="channel_item flex b pc"
        :class="{
          active: !!item.url && item.name === tabName,
          disabled: !item.url
        }"
      >
        <!-- <img :src="item.icon" alt="" /> -->
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import throttle from 'lodash/throttle';
import { getChannel } from '@/service/index';
import { query2Obj, is3mEnv } from '@/utils';
import sessionStorage from '@/utils/storage/sessionStorage';
import { getSiteConfig } from '@/service/common';
import { opCartCount, opHomeMenu } from '@/service/opApis';
import { getCustomId, logger, setTitle, showToast } from '@/common';
// 复用 banner 那套链接规整（截自有域名 + h5 历史路径 → PC 路由）
import { normalizeBannerLink } from '@/service/goods';

// ===== 硬编码配置集中在这里，方法里只保留流程 =====

// 栏目默认小图标（定制站首页 / 商家入驻共用）
const DEFAULT_ICON =
  '//image.pandayoufu.com/imags/20200630/616a3e6367a50320f9da61b91dba3c2a1031.png-pc_normal_jpg';

// 定制站的「首页」入口（万恶的客户需要这样定制，不具有复用性）
const buildHomeChannel = url => ({
  action: 'jump',
  activity_type: '',
  custom_id: 0,
  icon: DEFAULT_ICON,
  id: 0,
  name: '首页',
  type: 'normal',
  url
});
const HOST_HOME_CHANNEL = {
  'taitan.pandayoufu.com': buildHomeChannel('/home?channel_id=0'),
  '3m.pandayoufu.com': buildHomeChannel('/home?custom_id=362')
};

// 3m 定制专场（id 即 channel_id，顺序固定；url 由 path 再拼 channel_id / custom_id）
const IS3M_CUSTOM_ID = 806;
const IS3M_CHANNELS = [
  {
    id: 2137,
    name: '3M女神节礼包',
    path: '/partition?mode=exchange',
    icon: '//image.pandayoufu.com/lbdh_icon.png'
  },
  {
    id: 2138,
    name: '星巴克',
    path: '/activity?mode=exchange',
    icon: '//image.pandayoufu.com/lbdh_icon.png'
  },
  {
    id: 10,
    name: '优选商城',
    path: '/mall',
    icon:
      '//image.pandayoufu.com/imags/20200630/616a3e6367a50320f9da61b91dba3c2a1031.png'
  },
  {
    id: 15,
    name: '熊猫电影',
    path: '/movie',
    icon:
      '//image.pandayoufu.com/imags/20200630/cded74a74c65ee44054683b7c455ca793063.png'
  },
  {
    id: 13,
    name: '熊猫生日',
    path: '/birthday',
    icon:
      '//image.pandayoufu.com/imags/20200630/9b24def675df28ebb1bd6eaf3c88f8af9646.png'
  },
  {
    id: 34,
    name: '生活服务',
    path: '/live_service',
    icon:
      '//image.pandayoufu.com/imags/20200630/e5992463477aa7606de8a608e4b39a267183.png'
  },
  {
    id: 11,
    name: '景点门票',
    path: '/tour',
    icon:
      '//image.pandayoufu.com/imags/20210210/2d21d8f29ac1ef1949350ad5f5e819b58053.png'
  }
  // 另有两个 3m 入口暂未启用（原始 url 留档）：
  // 熊猫书馆 /jumptrans/wait?merchant_tag=jinli&type=index&active_code=ytBUWZOAzS0U69Eh2OhPLAIeIxlnoHO-06O0WSH3vwM=&channel_id=51&custom_id=817
  // 熊猫服装 /clothing/ct_store?channel_id=1330&custom_id=806
];

// PC 后补的专场入口（仅 pcmall 站）
const EXTRA_CHANNELS = [
  {
    action: 'jump',
    custom_id: null,
    icon: '',
    name: '企业定制',
    url: '/festival_channel?activity_type=1'
  },
  {
    action: 'jump',
    custom_id: null,
    icon: '',
    name: '节日礼包',
    url: '/festival_channel?activity_type=2'
  }
];

// 商家入驻入口只在正式站 / 测试站 / 本地开发展示
const BUSINESS_HOSTS = [
  'pcmall.pandayoufu.com',
  'www.pandayoufu.com',
  'pcmall-test.pandayoufu.com'
];
const BUSINESS_CHANNEL = {
  action: 'jump',
  activity_type: '',
  custom_id: -1,
  icon: DEFAULT_ICON,
  id: -1,
  name: '商家入驻',
  type: 'normal',
  url: '/business_settlement?channel_id=-1'
};

// PC 没有对应频道页的入口 → 替代页
const SPECIAL_JUMPS = { 熊猫书馆: '/private_school' };

// h5 首页菜单路径 → PC 路由的补充映射。
// 自有域名、/birthday/branddetails → /birthday/brand_details、
// /birthday/classifydetails → /birthday/list、/activity|/partition → /exchange 都由
// normalizeBannerLink 统一处理，这里只补菜单里另外几种（PC 与 h5 路由名不同）
const MENU_PATH_MAP = [
  // h5 的定制首页是 /custom_home，PC 对应 /home
  { re: /^\/custom_home/i, to: '/home' }
];

// 规整首页菜单的 url：先走通用规整，再做菜单专属映射
function normalizeMenuUrl(url) {
  const next = normalizeBannerLink(url);
  if (!next || next.charAt(0) !== '/') return next;
  const [path, query = ''] = next.split('?');
  const hit = MENU_PATH_MAP.find(item => item.re.test(path));
  if (!hit) return next;
  const nextPath = path.replace(hit.re, hit.to);
  return query ? `${nextPath}?${query}` : nextPath;
}

// channel_type → 路由映射（对应 h5 views/handleChannel/tools.js 的 channelTypeMatchUrl），
// 路径换成本项目的真实路由；PC 没有对应页面的类型不列在这里，映射不到时只能用接口给的 url
const CHANNEL_TYPE_MAP = {
  home: '/home',
  normal: '/mall',
  // 定制平台首页（h5 是 /custom_home，PC 对应 /home）
  customHome: '/home',
  // 生日专区：h5 新版的路由是 /birthday2，PC 统一走 /birthday
  // （/birthday2 由 main.js 的路由守卫改道，这里直接给最终地址，少一次重定向）
  birthday: '/birthday',
  privilege: '/life_privilege',
  life: '/live_service',
  movie: '/movie',
  exchange: '/exchange',
  tour: '/tour'
};

// 按 channel_type 拼目标地址（对齐 h5 frontRouteToChannel：路径 + channel_id，再带上当前定制 id）
function buildChannelTypeUrl(item = {}) {
  const typeKey = item.type || item.channel_type;
  if (!typeKey) return '';
  const path =
    CHANNEL_TYPE_MAP[typeKey === 'custom_home' ? 'customHome' : typeKey];
  if (!path) return '';
  const query = {};
  const channelId = item.channel_id || item.id;
  if (channelId !== undefined && channelId !== null && channelId !== '') {
    query.channel_id = channelId;
  }
  const customId = getCustomId();
  if (customId) {
    query.custom_id = customId;
  }
  const queryStr = Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&');
  return queryStr ? `${path}?${queryStr}` : path;
}

// 菜单项的目标地址：接口给了 url 就用它（可能带商品/活动参数），
// 没给（或只是首页占位 '/'）时按 channel_type 映射出 PC 路由
function resolveChannelUrl(item = {}) {
  const url = item.url ? normalizeMenuUrl(item.url) : '';
  if (url && url !== '/') return url;
  return buildChannelTypeUrl(item);
}

// 站内 url 在 PC 路由表里是否有对应页面（用于过滤 channelData）：
//   - 没有 url 的项不判断：保持原有「展示但不可点」的 disabled 行为
//   - 外链（http/https）由 changeChannel 直接新窗口打开，不判断
//   - 其余取路径部分交给路由匹配（vue-router.resolve），匹配不到任何路由记录
//     说明 PC 没有这个页面（例：接口给的 /canShiHui?channel_id=4348，
//     路由表里没有这条，点进去是空白页）
function hasRoute(router, url) {
  if (!url || /^https?:/i.test(url)) return true;
  const path = url.split('?')[0].split('#')[0];
  if (!path || path.charAt(0) !== '/') return true;
  try {
    const { matched } = router.resolve(path).route;
    // 路由表目前没有通配兜底，匹配不到时 matched 为空；
    // 万一以后加了 404 通配路由，这里也要把通配记录排除掉
    return matched.length > 0 && matched[0].path !== '*';
  } catch (err) {
    // 解析失败的地址同样不可用，不展示
    return false;
  }
}

// 专场栏去重：接口（h5 的 /v1/home/menu）与 PC 后补项 / 定制站专属项拼在一起后，
// 会出现同名或同地址的入口（实测有同一入口在列表里出现两次的情况，红条上就会重复显示）。
// 按「名字或最终跳转地址」判重，保留先出现的那条；两个字段都为空的项不参与判重（照旧展示）
function dedupeChannels(list = []) {
  const seenName = new Set();
  const seenUrl = new Set();
  return list.filter(item => {
    const name = item.name || '';
    const url = item.url || '';
    if ((name && seenName.has(name)) || (url && seenUrl.has(url))) return false;
    if (name) seenName.add(name);
    if (url) seenUrl.add(url);
    return true;
  });
}

export default {
  data() {
    return {
      channelData: [],
      isHome: false,
      tabName: '',
      // 菜单请求序号：custom_id 变化会重新拉菜单，用它丢弃过期响应，避免旧结果覆盖新结果
      menuSeq: 0,
      // 频道行是否超出（超出才开启拖动与抓取光标）
      canScroll: false,
      // 拖动左右滑动：起点 / 起始滚动位置 / 是否正在拖 / 是否已拖动
      dragging: false,
      dragMoved: false,
      dragStartX: 0,
      dragStartScrollLeft: 0
    };
  },
  mounted() {
    this.throttleResize = throttle(this.updateScrollable, 200);
    window.addEventListener('resize', this.throttleResize);
  },
  beforeDestroy() {
    if (this.throttleResize) {
      window.removeEventListener('resize', this.throttleResize);
    }
    // 拖动中切走页面：把挂在 document 上的监听摘掉
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
  },
  methods: {
    // 频道行内容是否超出（超出才允许拖动，并给出抓取光标）
    updateScrollable() {
      const el = this.$refs.tabList;
      if (!el) return;
      this.canScroll = el.scrollWidth > el.clientWidth + 1;
    },
    // 按住拖动左右滑动（触控板/Shift+滚轮仍走原生横向滚动）
    onDragStart(e) {
      const el = this.$refs.tabList;
      if (!el || el.scrollWidth <= el.clientWidth) return;
      this.dragging = true;
      this.dragMoved = false;
      this.dragStartX = e.clientX;
      this.dragStartScrollLeft = el.scrollLeft;
      // 挂在 document 上：鼠标拖出行宽也不会中断
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
      // 阻止拖拽时选中文字
      e.preventDefault();
    },
    onDragMove(e) {
      if (!this.dragging) return;
      const el = this.$refs.tabList;
      if (!el) return;
      const dx = e.clientX - this.dragStartX;
      if (Math.abs(dx) > 4) this.dragMoved = true;
      el.scrollLeft = this.dragStartScrollLeft - dx;
    },
    onDragEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      document.removeEventListener('mousemove', this.onDragMove);
      document.removeEventListener('mouseup', this.onDragEnd);
    },
    // 频道菜单来源：优先用 h5 同一套接口（POST /v1/home/menu，opHomeMenu），
    // 失败时回退到 PC 原有的 POST /v1/home/left-menu（getChannel），保证原有功能不受影响
    async initChannel() {
      let list = [];
      const seq = ++this.menuSeq;
      try {
        // custom_id / channel_id / token 等公共参数由 op 请求层统一注入（见 common/injectCustomId）
        const menuRes = await opHomeMenu();
        list = (menuRes && menuRes.modules) || [];
      } catch (err) {
        logger({
          message: '获取首页菜单失败（/v1/home/menu），回退 left-menu',
          error: err
        });
        const data = await getChannel().catch(() => null);
        list = (data && data.modules) || [];
      }
      // 等待期间 custom_id 变了、又发了新请求，本次结果作废
      if (seq !== this.menuSeq) return;
      // 过滤 PC 走不了的项：
      //  1) channel_type / type 为 app 的频道：h5 需要再请求 fetchAppChannelUrl 换跳转地址，PC 不接
      //  2) 扩展应用（action 为 ext_app，点餐等）：不在 PC 专场栏展示
      //  3) 首页入口（url 为 '/' 的 jump 项）不在专场栏展示，与 h5 opHomeMenu 的处理一致
      list = list.filter(
        item =>
          (item.type || item.channel_type) !== 'app' &&
          item.action !== 'ext_app' &&
          (item.action === 'jump' && item.url)
      );
      this.channelData = [
        ...list,
        // PC 后补的专场入口（仅 pcmall 站）
        ...(window.location.origin.includes('pcmall') ? EXTRA_CHANNELS : [])
      ];
      // 定制站（taitan / 3m）的专属入口
      this.applyHostChannel();
      this.addBusinessSettlement();
      // 统一算出每个入口的目标地址：接口给了 url 就规整成 PC 路由，
      // 没给 url 时按 channel_type 映射（接口数据与上面的硬编码项都过一遍）
      this.channelData = this.channelData
        .map(item => ({
          ...item,
          url: resolveChannelUrl(item)
        }))
        // 站内 url 在 PC 路由表里不存在的入口不展示（点进去是空白页）；
        // 走替代页的入口（SPECIAL_JUMPS，如 熊猫书馆 → /private_school）不受此限
        .filter(
          item =>
            Object.prototype.hasOwnProperty.call(SPECIAL_JUMPS, item.name) ||
            hasRoute(this.$router, item.url)
        );
      // 最后去重（判重用最终地址，所以放在 url 计算之后）：同名或同地址的入口只留先出现的那个
      this.channelData = dedupeChannels(this.channelData);
      this.setActiveTab();
    },
    // 首屏按当前路由高亮所属专场
    setActiveTab() {
      const channelId = this.$route.query.channel_id;
      // 1) 带 channel_id（/mall?channel_id=10）时按 channel_id 匹配
      if (channelId) {
        const hit = this.channelData.find(
          item => item.url && query2Obj(item.url).channel_id == channelId
        );
        if (hit) this.tabName = hit.name;
        return;
      }
      // 2) 否则按路径匹配；festival_channel 下企业定制 / 节日礼包路径相同、参数不同，
      //    要求完全一致，避免把两个入口一起点亮
      const { path, fullPath } = this.$route;
      const hit = this.channelData.find(item => {
        if (!item.url || item.url.indexOf(path) !== 0) return false;
        return fullPath.includes('festival_channel')
          ? fullPath === item.url
          : true;
      });
      if (hit) this.tabName = hit.name;
    },
    // 定制站的专属入口：taitan / 3m 在菜单最前面插「首页」，3m env 直接换成整套定制菜单
    applyHostChannel() {
      const hostHome = HOST_HOME_CHANNEL[window.location.host];
      if (hostHome) {
        this.channelData.unshift({ ...hostHome });
        return;
      }
      if (is3mEnv()) {
        this.channelData = IS3M_CHANNELS.map(({ id, name, path, icon }) => ({
          id,
          name,
          // path 自带 query（/partition?mode=exchange）时用 & 拼接
          url: `${path}${
            path.includes('?') ? '&' : '?'
          }channel_id=${id}&custom_id=${IS3M_CUSTOM_ID}`,
          custom_id: IS3M_CUSTOM_ID,
          icon,
          action: 'jump',
          sort: 0
        }));
      }
    },
    changeChannel(data = {}) {
      // 刚拖动过：这一次 click 是滑动手势的尾巴，不切换频道
      if (this.dragMoved) {
        this.dragMoved = false;
        return;
      }
      // 扩展应用（点餐等 ext_app）不是专场：不切 channel_id、不重查专场配置，
      // 按 h5 navigateModule 的处理跳转（维护中给提示）
      if (data.action === 'ext_app') {
        return this.toExtApp(data);
      }
      // 目标地址在 initChannel 里就算好了（接口 url 优先，没 url 时按 channel_type 映射），
      // 走到这里还没有地址说明这个频道在 PC 没有对应页面，点击不响应
      if (!data.url) return;
      // 外部链接（活动页/三方页）不在站内，直接新窗口打开，不参与 channel_id / 专场配置切换
      if (/^https?:/i.test(data.url)) {
        return window.open(data.url);
      }
      const channelId = query2Obj(data.url).channel_id;
      sessionStorage.set('channel_id', channelId);
      this.initBread();
      // 若切换的专场是商城;查询对应专场购物车商品数量
      if (data.url.includes('mall')) {
        this.getCartCount(channelId);
      }
      // 切换专场后重新查询对应专场配置
      this.getConfig();
      if (data.action !== 'jump') return;
      // PC 没有对应频道页的入口，落到替代页
      const specialPath = SPECIAL_JUMPS[data.name];
      if (specialPath) {
        this.tabName = data.name;
        return this.$router.push(specialPath);
      }
      this.goto(data.url);
    },
    // 站内路径走路由，外链新窗口打开（菜单里可能是三方页 / 活动页）
    goto(url) {
      if (/^https?:/i.test(url)) {
        return window.open(url);
      }
      this.$router.push({ path: url });
    },
    // 扩展应用入口（对齐 h5 navigateModule / PC birthday 页 toExtApp 的处理）：
    // is_maintain=2 时提示维护中，其余交给 goto 判断内外链
    toExtApp(item = {}) {
      const { is_maintain, maintain_content, url } = item;
      if (+is_maintain === 2) {
        return showToast({
          message: maintain_content || '当前维护中，暂不可进入'
        });
      }
      if (url) this.goto(url);
    },
    getConfig() {
      getSiteConfig()
        .then(res => {
          if (res.site_gray) {
            document.documentElement.style.filter = 'grayscale(100%)';
          }
          this.$store.commit('common/setConfig', res);
          setTitle(res.title);
        })
        .catch(err => {
          logger(err);
        });
    },
    // 商城专场要同步购物车角标数量
    getCartCount(channel_id) {
      opCartCount({ channel_id }).then(res => {
        this.$store.commit({
          type: 'cart/setCount',
          params: res.goods_number
        });
      });
    },
    initBread() {
      // 切换专场后清空面包屑
      sessionStorage.set('bread', []);
    },
    toHome() {
      this.isHome = true;
      this.$router.push({
        path: '/'
      });
    },
    // 商家入驻入口（配置见 BUSINESS_CHANNEL / BUSINESS_HOSTS）
    addBusinessSettlement() {
      if (
        BUSINESS_HOSTS.includes(window.location.host) ||
        process.env.NODE_ENV === 'development'
      ) {
        this.channelData.push({ ...BUSINESS_CHANNEL });
      }
    }
  },
  created() {
    this.initChannel();
    if (this.$route.name === 'home') {
      this.isHome = true;
    }
  },
  watch: {
    // 路由变化时按完整路径匹配高亮（redirectedFrom 覆盖重定向场景）
    $route() {
      const hit = this.channelData.find(
        item =>
          item.url &&
          (item.url === this.$route.fullPath ||
            item.url === this.$route.redirectedFrom)
      );
      if (hit) this.tabName = hit.name;
    },
    // 定制 id 变化时按新 id 重新拉菜单：
    // 首屏重定向（/ → /home?custom_id=362）时组件可能先于路由确定就创建了，
    // 那时读不到 custom_id，只能等它出现再拉一次
    '$route.query.custom_id'() {
      this.initChannel();
    },
    // 频道数据是异步来的：渲染完再判断是否超出（决定能不能拖动、要不要抓手光标）
    channelData() {
      this.$nextTick(this.updateScrollable);
    }
  }
};
</script>
<style lang="scss" scoped>
.channel {
  z-index: 98;
  @include background_primary($background-color);
  // width: 100%;
  // width: 1250px;
  // min-width: 1150px;
  position: absolute;
  left: 0;
  top: 0;
  .Tab {
    // width: 100%;
    width: 1150px;
    height: 44px;
    @include background_primary($background-color);
    flex-wrap: nowrap;
    // 频道超出时行内左右滑动（原来这两行是注释掉的，频道多了会直接溢出到容器外，
    // 没有滚动条也没有拖动，右边的频道就点不到了）
    overflow-x: auto;
    overflow-y: hidden;
    // 滚动条隐藏：44px 的导航条上出现滚动条会顶高/难看，靠拖动或触控板滚动
    &::-webkit-scrollbar {
      height: 0;
    }
    // 内容超出：提示可拖动
    &.canScroll {
      cursor: grab;
    }
    &.dragging {
      cursor: grabbing;
      user-select: none;
    }
    .channel_item {
      // 频道名不换行：原来没有 white-space，配上固定 44px 行高，
      // 名字一长就在格子里折成 2~3 行往下溢出，和下面那条导航叠在一起（看着就是糊成一片）；
      // 原来还有 max-width: 115px，配合换行会把名字挤得更碎，现在按内容宽度排，
      // 超出的部分交给 .Tab 横向滚动
      white-space: nowrap;
      flex-shrink: 0;
      height: 44px;
      line-height: 44px;
      display: flex;
      align-items: center;
      // 频道之间留出间距（原来 padding 被注释掉，相邻名字直接贴在一起分不清）
      padding: 0 16px;
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
      }
      span {
        font-size: 16px;
        color: #ffffff;
      }
      &:hover {
        @include background_active($background-hover-color);
        img {
          filter: none;
        }
        span {
          color: #fff;
        }
      }
      // 映射不到落地页的入口：PC 没有对应页面，点击不响应（changeChannel 直接 return），hover 也不再高亮
      &.disabled {
        cursor: default;
        &:hover {
          background: transparent;
        }
      }
    }
    .active {
      @include background_active($background-hover-color);
      img {
        filter: none;
      }
      span {
        font-weight: bold;
        color: #fff;
      }
    }
  }
}
</style>
